import shippingReducer from "./reducers/shippingReducer";
import authReducer from "./reducers/authReducer";
import inventoryReducer from "./reducers/inventoryReducer";
import selectionReducer from "./reducers/selectionReducer";
import viewReducer from "./reducers/viewReducer";
import windowsReducer from "./reducers/windowsReducer";
import {reducer as formReducer} from "redux-form/immutable";
import warehousePackagesReducer from "./reducers/warehousePackagesReducer";

import {combineReducers} from 'redux-immutable';

const reducers = {
  auth: authReducer,
  shipping: shippingReducer,
  inventory: inventoryReducer,
  selection: selectionReducer,
  view: viewReducer,
  windows: windowsReducer,
  warehousePackages: warehousePackagesReducer,
  form: formReducer,
}

export default combineReducers(reducers);
